module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('myo-sidebar', [_c('div', {
    staticClass: "p3 bg-light-blue"
  }, [_c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Handlekurv")]), _vm._v(" "), (_vm.state.is('loading')) ? _c('div', {
    staticClass: " center"
  }, [_c('div', {
    staticClass: "md-spinner md-theme-default md-indeterminate",
    staticStyle: {
      "width": "20px",
      "height": "20px"
    }
  }, [_c('svg', {
    staticClass: "md-spinner-draw",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "md-spinner-path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "stroke-width": "3.5"
    }
  })])])]) : (_vm.$root.$data.cart) ? _c('div', {
    staticClass: "mt1"
  }, [(_vm.$root.$data.cart.items.length === 0) ? _c('div', [_c('div', {
    staticClass: "fz18 text-blue"
  }, [_vm._v("Handlekurven er tom...")])]) : _c('div', {
    staticClass: "clearfix mt1 bold"
  }, [_c('div', {
    staticClass: "col col-6 fz18 text-blue"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.gross_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 text-dark-grey right-align"
  }, [_vm._v("\n            " + _vm._s(_vm.$root.$data.cart.items.length) + "\n            "), (_vm.$root.$data.cart.items.length > 1) ? _c('span', [_vm._v("varer")]) : _c('span', [_vm._v("vare")])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-grey pt3 pl3 pr3 pb1"
  }, [_vm._v("Mine sider")]), _vm._v(" "), _c('router-link', {
    staticClass: "myo-list-item",
    attrs: {
      "to": "/app/shop/my-orders"
    }
  }, [_vm._v("Mine ordre")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey pt3 pl3 pr3 pb1"
  }, [_vm._v("Handle")]), _vm._v(" "), _c('router-link', {
    staticClass: "myo-list-item",
    attrs: {
      "to": "/app/shop/category/all"
    }
  }, [_vm._v("Alle produkter")]), _vm._v(" "), _c('router-link', {
    staticClass: "myo-list-item",
    attrs: {
      "to": "/app/shop/category/expo-products"
    }
  }, [_vm._v("Expo-produkter")]), _vm._v(" "), _c('router-link', {
    staticClass: "myo-list-item",
    attrs: {
      "to": "/app/shop/category/digital-print"
    }
  }, [_vm._v("Digitale trykksaker")])], 1), _vm._v(" "), _c('div', {
    staticClass: "px3 py2 italic text-grey"
  }, [_vm._v("Flere produkter kommer snart...")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "p3"
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a7f182f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/templates/Shop.vue
// module id = 642
// module chunks = 1